import { render, staticRenderFns } from "./Dubbing.vue?vue&type=template&id=3df5f1b4&scoped=true"
import script from "./Dubbing.vue?vue&type=script&lang=js"
export * from "./Dubbing.vue?vue&type=script&lang=js"
import style0 from "./Dubbing.vue?vue&type=style&index=0&id=3df5f1b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df5f1b4",
  null
  
)

export default component.exports